import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getUserInfoById } from "../../../redux/userReducer/actionsUser";
import { loginByLoginPassword } from "../../../redux/loginReduser/actionLogin";
import { logoutUserById } from "../../../redux/actions";

import ConfirmationModal from "./confirmationModal/confirmationModal";

import Form from "react-bootstrap/Form";
import Cookies from "js-cookie";

import eye_off from "../../../resourсes/eye-off.svg";
import eye from "../../../resourсes/eye.svg";

import styles from "./LoginPage.module.css";

export default function LoginPage({ handleLogin }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isAuthorized = Cookies.get("isAuthorized");
  const refreshToken = Cookies.get("refreshToken");
  const userId = Cookies.get("userId");

  const [userEmail, setUserEmail] = useState("");
  const [userPas, setUserPas] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginData = useSelector((state) => {
    return state.authLoginReducer.authData;
  });

  const authLoginReducer = useSelector((state) => {
    const { authLoginReducer } = state;
    return authLoginReducer;
  });
  const userInfo = useSelector((state) => state.dictionaryReducer.userInfo);

  const handleButtonClick = async (e) => {
    e.preventDefault();
    if (!userEmail) {
      setEmailError("Поле 'Логин' обязательно для заполнения");
    } else {
      setEmailError("");
    }
    if (!userPas) {
      setPasswordError("Поле 'Пароль' обязательно для заполнения");
    } else {
      setPasswordError("");
    }

    if (userEmail && userPas) {
      Cookies.set("login", userEmail);
      dispatch(
        loginByLoginPassword({
          login: userEmail,
          password: userPas,
        }),
      );
    }
  };

  const handleUserEmail = (e) => {
    setUserEmail(e.target.value);
  };

  const handleUserPas = (e) => {
    setUserPas(e.target.value);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleConfirmModal = (confirmed) => {
    if (confirmed) {
      setShowModal(false);
    }
  };

  useEffect(() => {
    const accessToken = Cookies.get("accessToken");

    if (accessToken && isAuthorized === "true") {
      navigate("/firstLogin");
      handleLogin("firstLogin");
    }

    if (
      accessToken &&
      isAuthorized === "false" &&
      authLoginReducer.authData.isLogin
    ) {
      dispatch(getUserInfoById(userId));
    }

    if (!accessToken && !isAuthorized) {
      const userId = Cookies.get("userId");

      if (userId) {
        dispatch(logoutUserById(userId));
      }
      navigate("login");
      handleLogin("");
    }

    if (
      accessToken &&
      accessToken === "null" &&
      refreshToken &&
      refreshToken === "null"
    ) {
      if (userId) {
        dispatch(logoutUserById(userId));
      }
      handleLogin("");
      navigate("login");
    }
  }, [refreshToken, navigate, authLoginReducer.authData.isLogin]);

  useEffect(() => {
    if (userInfo.roles) {
      const allowedIds = [1, 6, 8];
      const hasAllowedRole = userInfo.roles.some((role) =>
        allowedIds.includes(role.roleid),
      );

      if (hasAllowedRole) {
        navigate("/accountManagement");
        handleLogin("login");
      } else {
        navigate("/smallboatsreg");
        handleLogin("login");
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (!loginData.error) {
      setEmailError("");
      setPasswordError("");
    }

    if (loginData.error) {
      setEmailError("Неверный логин или пароль");
      setPasswordError("Неверный логин или пароль");
    }
  }, [loginData]);

  useEffect(() => {
    if (loginData.errorText) {
      setShowModal(true);
    }
  }, [loginData, loginData.errorText]);

  return (
    <>
      <div className={styles["form-container"]}>
        <div className={styles["img-block"]}></div>
        <Form className={styles["login-form"]}>
          <h1 className={styles["main-text"]}>Войти</h1>
          <Form.Group
            controlId="formBasicEmail"
            className={styles["form-group-block"]}
          >
            <label className={styles["label"]}>Логин</label>
            <div className={styles["input-group"]}>
              <input
                className={styles["form-input"]}
                id={"formBasicEmail"}
                placeholder="Введите логин"
                type={"text"}
                value={userEmail}
                onChange={handleUserEmail}
              />
            </div>
            <Form.Text className="text-danger">{emailError}</Form.Text>
          </Form.Group>

          <Form.Group
            controlId="formBasicPassword"
            className={styles["form-group-block"]}
          >
            <label className={styles["label"]}>Пароль</label>
            <div className={styles["input-group"]}>
              <input
                className={styles["form-input"]}
                id={"formBasicPassword"}
                placeholder="Введите пароль"
                type={showPassword ? "text" : "password"}
                value={userPas}
                onChange={handleUserPas}
              />
              <div className={styles["input-group-img-block"]}>
                <img
                  className={styles["input-group-img"]}
                  onClick={togglePasswordVisibility}
                  style={{ cursor: "pointer" }}
                  src={showPassword ? eye_off : eye}
                  title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                  alt={showPassword ? "Скрыть пароль" : "Показать пароль"}
                />
              </div>
            </div>
            <Form.Text className="text-danger">{passwordError}</Form.Text>
          </Form.Group>

          <button
            onClick={(e) => handleButtonClick(e)}
            className={styles["login-button-form"]}
          >
            ВХОД
          </button>
        </Form>
      </div>
      <ConfirmationModal
        show={showModal}
        message={loginData.errorText}
        onConfirm={handleConfirmModal}
        onHide={handleCloseModal}
      />
    </>
  );
}
